var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTeam(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 13,
    viewBox: "0 0 20 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.12864 6.69673C7.76566 6.69673 9.09272 5.36966 9.09272 3.73264C9.09272 2.09562 7.76566 0.768555 6.12864 0.768555C4.49162 0.768555 3.16455 2.09562 3.16455 3.73264C3.16455 5.36966 4.49162 6.69673 6.12864 6.69673Z",
    stroke: "#F4F2F8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4778 6.69673C16.1148 6.69673 17.4418 5.36966 17.4418 3.73264C17.4418 2.09562 16.1148 0.768555 14.4778 0.768555C12.8407 0.768555 11.5137 2.09562 11.5137 3.73264C11.5137 5.36966 12.8407 6.69673 14.4778 6.69673Z",
    stroke: "#F4F2F8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1986 11.5473C18.9569 10.4757 18.3579 9.51823 17.4999 8.83221C16.6419 8.14619 15.5761 7.77246 14.4776 7.77246C13.3791 7.77246 12.3132 8.14619 11.4553 8.83221C10.5973 9.51823 10.2885 9.82449 10.0469 10.8961",
    stroke: "#F4F2F8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8492 11.5473C10.6075 10.4757 10.0085 9.51823 9.15051 8.83221C8.29255 8.14619 7.22672 7.77246 6.12821 7.77246C5.02969 7.77246 3.96387 8.14619 3.1059 8.83221C2.24794 9.51823 1.64889 10.4757 1.40723 11.5473",
    stroke: "#F4F2F8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeam);
export default __webpack_public_path__ + "static/media/team.03f4419e5c8e21c2cfbaa03fbb985367.svg";
export { ForwardRef as ReactComponent };